var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,2c-5.5,0-9.9,4.4-9.9,9.9c0,1.8,0.5,3.4,1.3,5L2,22l5.3-1.4c1.5,0.8,3.1,1.2,4.7,1.2c5.5,0,9.9-4.5,9.9-9.9 c0-2.6-1-5.1-2.9-7C17.2,3,14.7,2,12,2 M12.1,3.7c2.2,0,4.3,0.9,5.8,2.4c1.5,1.5,2.4,3.6,2.4,5.8c0,4.5-3.7,8.2-8.2,8.2 c-1.5,0-2.9-0.4-4.2-1.1l-0.3-0.2l-3.1,0.8l0.8-3l-0.2-0.3c-0.8-1.3-1.3-2.8-1.3-4.4C3.8,7.4,7.5,3.7,12.1,3.7 M8.5,7.3 c-0.2,0-0.4,0.1-0.7,0.3C7.6,7.9,7,8.5,7,9.7c0,1.2,0.9,2.4,1,2.6c0.1,0.2,1.8,2.7,4.3,3.7c0.6,0.3,1.1,0.4,1.4,0.5 c0.6,0.2,1.1,0.2,1.6,0.1c0.5-0.1,1.5-0.6,1.7-1.2c0.2-0.6,0.2-1.1,0.1-1.2c-0.1-0.1-0.2-0.2-0.5-0.3c-0.3-0.1-1.5-0.7-1.7-0.8 c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.6,0.8-0.8,1c-0.1,0.2-0.3,0.2-0.5,0.1c-0.3-0.1-1.1-0.4-2-1.2c-0.7-0.7-1.2-1.5-1.4-1.7 c-0.1-0.2,0-0.4,0.1-0.5c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0-0.3,0-0.4c-0.1-0.1-0.6-1.4-0.8-1.8 C9.4,7.3,9.2,7.4,9,7.3C8.9,7.3,8.7,7.3,8.5,7.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.4dd06274.svg";
export { ForwardRef as ReactComponent };